import _get from 'lodash/get';
import { ColumnConfig, CellConfig } from '../../../molecules/tableInputField';
import makeCellRenderer from '../../../molecules/CellRenderers/makeCellRenderer';
import SortOrder from './components/SortOrder';
import { FIELD_IDS } from '../multiSort.constants';
import styles from '../multiSort.module.scss';
var setGetValueFromOnChange = function setGetValueFromOnChange(_nestingPath, params) {
  return _get(params, 'params.value');
};
var SORT_ORDER_FIELD = new ColumnConfig(FIELD_IDS.SORT_ORDER).setAccessor(FIELD_IDS.SORT_ORDER).addCellConfig(new CellConfig().setComponent(makeCellRenderer(SortOrder))).setGetValueFromOnChange(setGetValueFromOnChange).setMinWidth(240).setHeaderClassName(styles.columnHeader);
export default SORT_ORDER_FIELD;